import { FLOW_CREDITS_PURCHASE_MODAL_RECEIVE } from '../constants';

export const flowCreditPurchaseModal = (
    state = { },
    action
) => {
    switch (action.type) {
        case FLOW_CREDITS_PURCHASE_MODAL_RECEIVE:
            return action.payload;
        default:
            return state;
    }
};
